import React from 'react';
import Icon from './Icon';

const BoundaryIcon = (props) => (
    <Icon {...props}>
        <path
            d="M7.5 6A1.5 1.5 0 1 1 4.5 6A1.5 1.5 0 0 1 7.5 6ZM19.5 5A1.5 1.5 0 1 1 16.5 5A1.5 1.5 0 0 1 19.5 5ZM20.5 18A1.5 1.5 0 1 1 17.5 18A1.5 1.5 0 0 1 20.5 18ZM6.5 17A1.5 1.5 0 1 1 3.5 17A1.5 1.5 0 0 1 6.5 17ZM7.5 5.9L16.5 5.1M18.1 6.5L18.9 16.5M17.5 17.9L6.5 17.1M5.1 15.5L5.9 7.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default BoundaryIcon;
